module.exports = __webpack_public_path__ + "static/media/caution.be48eb82.svg";